module.exports = __webpack_public_path__ + "751c8f87270b925c26c412ec7620827f.svg";